import React, {
    createContext,
    useContext,
    useEffect,
    useState
} from "react";

import { ToastService, ToastType } from "./ToastService";

const ToastContext = createContext<{
    showToast: (message: string, type?: ToastType) => void;
} | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode; }> = ({ children }) => {
    const [toast, setToast] = useState<{ message: string; type: ToastType; } | null>(null);

    const showToast = (message: string, type: ToastType = "success") => {
        setToast({ message, type });
        setTimeout(() => { setToast(null); }, 3000);
    };

    useEffect(() => {
        ToastService.register(showToast);

        return () => { ToastService.unregister(); };
    }, []);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}

            {toast && (
                <div className={`center app-toast app-toast-${toast.type}`}>
                    <span>{toast.message}</span>
                </div>
            )}
        </ToastContext.Provider>
    );
};

export const useToast = () => {
    const context = useContext(ToastContext);

    if (!context) {
        throw new Error("useToast must be used inside ToastProvider");
    }

    return context;
};